import React, { Component } from "react";
import "./ProgressBar.scss";

class ProgressBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      complementPercentage: parseInt(this.props?.percent) || 0
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.percent !== this.props.percent) {
      this.setState({
        complementPercentage: parseInt(this.props.percent)
      });
    }
  }

  render() {
    return <div className="progress__bar">
      <div className="c__progress" style={{width: `${this.state.complementPercentage}%`}}>
        {this.state.complementPercentage}%
      </div>
    </div>;
  }
}

export default ProgressBar;
